import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import store from './components/app/store/store';
import theme from './components/utils/theme/theme';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from '@mui/material/styles';
import DiscountBanner from './components/banner/DiscountBanner';

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<Provider store={store}>
				<DiscountBanner/>
				<App />
				<ToastContainer />
			</Provider>
		</ThemeProvider>
	</React.StrictMode>
);
